import {PHASES} from "../../constants/phases";
import {getWarPhaseStageIcon} from "./getWarPhaseStageIcon";

export const getPhaseIcon = (phase, warStage, gameResults) => {
  if(gameResults) {
    return '/img/icons/win points white.png'
  }

  // Без этапа (оверлей «Ваш ход!» в начале войны) — иконка самой фазы из
  // списка ниже: getWarPhaseStageIcon(undefined) вернул бы undefined, и
  // маска иконки ушла бы на url("undefined") — пусто и 404
  if (phase === PHASES.WAR && warStage) {
    return getWarPhaseStageIcon(warStage);
  }

  const phaseIcons = {
    [PHASES.FIELD_PREPARATION]: '/img/icons/cell white.png',
    [PHASES.SETUP]: '/img/icons/flag white.png',
    [PHASES.SUPPLY]: '/img/icons/supply white.png',
    [PHASES.CONSTRUCTION]: '/img/icons/hammer white.png',
    [PHASES.WAR]: '/img/icons/barracks white.png'
  };

  return phaseIcons[phase] || phase;
};